import { DATE_RANGE_PRESETS, DateRange, DateRangePreset } from '@/types/admin/analytics';

interface Props {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

/**
 * Date Range Selector
 * Allows user to select predefined date ranges
 * Styled to match the brand design
 */
export function DateRangeSelector({ value, onChange }: Props) {
  const handlePresetClick = (preset: DateRangePreset) => {
    onChange(DATE_RANGE_PRESETS[preset]);
  };

  // Determine which preset is currently selected
  const currentPreset = Object.entries(DATE_RANGE_PRESETS).find(
    ([, range]) => range.start === value.start && range.end === value.end
  )?.[0] as DateRangePreset | undefined;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-brand-electric-blue/10 rounded-full flex items-center justify-center">
          <svg className="w-4 h-4 text-brand-electric-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <span className="text-sm font-semibold text-brand-dark-blue">Date Range</span>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {(Object.keys(DATE_RANGE_PRESETS) as DateRangePreset[]).map((preset) => (
          <button
            key={preset}
            onClick={() => handlePresetClick(preset)}
            className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-300 ${
              currentPreset === preset
                ? 'bg-gradient-to-r from-brand-electric-blue to-brand-dark-blue text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                : 'bg-white text-gray-700 border border-gray-200 hover:border-brand-electric-blue/50 hover:bg-brand-light-gray hover:text-brand-dark-blue'
            }`}
          >
            {preset}
          </button>
        ))}
      </div>
    </div>
  );
}
